import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import DashboardLayout from "../layouts/DashboardLayout";
import PosScreenLayout from "../layouts/PosScreenLayout";
import Product from "../pages/Product";
import Category from "../pages/Category";
import PurchaseStock from "../pages/PurchaseStock";
import CutPiece from "../pages/CutPiece";
import Stock from "../pages/Stock";
import SalesLedger from "../pages/SalesLedger";
import Customer from "../pages/Customer";
import Transaction from "../pages/Transaction";
import HoldCart from "../pages/HoldCart";
import PosScreen from "../pages/PosScreen";
import AddCustomer from "../pages/Customer/AddCustomer";
import AddCategory from "../pages/Category/AddCategory";
import AddProduct from "../pages/Product/AddProduct";
import ReconcileStock from "../pages/PurchaseStock/ReconcileStock";
import SalesLedgerDetails from "../pages/SalesLedger/SalesLedgerDetails";
import Login from "../layouts/LoginLayout"; // Import the login page
import EditProduct from "../pages/Product/EditProduct";
import EditCategory from "../pages/Category/EditCategory";
import EditCustomer from "../pages/Customer/EditCustomer";
import Purchase from "../pages/PurchaseStock/Purchase";
import Profile from "../pages/Profile";
import TransactionDetails from "../pages/Transaction/TransactionDetails";
import StockDetail from "../pages/Stock/StockDetail";
import CategoryDetail from "../pages/Category/CategoryDetail";
import PrivateRoute from "./PrivateRoute";

type Props = {};

const Router = (props: Props) => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/product" element={<Product />} />
        <Route path="/product/create" element={<AddProduct />} />
        <Route path="/product/edit/:id" element={<EditProduct />} />
        <Route path="/category" element={<Category />} />
        <Route path="/category/add" element={<AddCategory />} />
        <Route path="/category/edit/:id" element={<EditCategory />} />
        <Route path="/category/detail/:id" element={<CategoryDetail />} />
        <Route path="/purchase-stock" element={<PurchaseStock />} />
        <Route path="/purchase-stock/reconcile" element={<ReconcileStock />} />
        <Route path="/cut-piece" element={<CutPiece />} />
        <Route
          path="/sales-ledger/detail/:id"
          element={<SalesLedgerDetails />}
        />
        <Route path="/sales-ledger" element={<SalesLedger />} />
        <Route path="/purchase-stock/:id" element={<Purchase />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/stock/:id" element={<StockDetail />} />
      </Route>
      <Route
        element={
          <PrivateRoute>
            <PosScreenLayout />
          </PrivateRoute>
        }
      >
        <Route path="/pos-screen/:pk?" element={<PosScreen />} />
        <Route path="/hold-cart" element={<HoldCart />} />
        <Route path="/transaction" element={<Transaction />} />
        <Route
          path="/transaction/details/:id"
          element={<TransactionDetails />}
        />
        <Route path="/customer" element={<Customer />} />
        <Route path="/customer/add" element={<AddCustomer />} />
        <Route path="/customer/edit/:id" element={<EditCustomer />} />
      </Route>
      <Route path="/*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default Router;
